import React from 'react';
import './Select.css';

/**
 * Select Component
 * Standardized select dropdown
 * 
 * @param {string} label - Select label
 * @param {Array} options - Array of {value: string, label: string}
 * @param {string} value - Selected value
 * @param {function} onChange - Change handler: (value: string) => void
 * @param {string} placeholder - Placeholder text
 * @param {string} error - Error message
 * @param {boolean} disabled - Disabled state
 * @param {boolean} required - Required field indicator
 * @param {string} helperText - Helper text below input
 * @param {string} className - Additional CSS classes
 */
const Select = ({
  label,
  options = [],
  value,
  onChange,
  placeholder,
  error,
  disabled = false,
  required = false,
  helperText,
  className = ''
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const selectId = `select-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`select-container ${error ? 'error' : ''} ${className}`.trim()}>
      {label && (
        <label htmlFor={selectId} className="select-label">
          {label}
          {required && <span className="select-required">*</span>}
        </label>
      )}
      <select
        id={selectId}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        required={required}
        className={`select ${error ? 'error' : ''}`.trim()}
        aria-required={required}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${selectId}-error` : helperText ? `${selectId}-helper` : undefined}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {(error || helperText) && (
        <div className="select-footer">
          {error && (
            <span id={`${selectId}-error`} className="select-error" role="alert">
              {error}
            </span>
          )}
          {!error && helperText && (
            <span id={`${selectId}-helper`} className="select-helper">
              {helperText}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default Select;

